module.exports = __webpack_public_path__ + "media/applicants/device_signup_8-fr-50a90cc3.jpg";